import React from "react";
import "./Loader.scss";
export type Overlay = "lightOverlay" | "darkOverlay" | "darkerOverlay";
export interface Props {
  loaderClass?: string;
  loaderId?: any;
  ariaLabel?: any;
  loaderBackground?: Overlay;
  children: any;
}
const Loader = ({
  loaderClass,
  loaderId,
  children,
  ariaLabel,
  loaderBackground = "lightOverlay",
}: Props) => {
  return (
    <div
      role="alert"
      aria-label={ariaLabel}
      className={`mfg-loader${loaderClass ? " " + loaderClass : ""}${
        loaderBackground ? " " + loaderBackground : ""
      }`}
      id={loaderId}
    >
      <span>{ children }</span>
    </div>
  );
};

export default Loader;
